import React from 'react'
import { Box} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';

// const firstRow = {
//     id: 1,
//     Date: "",
//     Invoice: "",
//     Payment: "",
//     Balance: "",
    
    
// }
const dataGridStyle = {
  root: {
    "& .MuiDataGrid-root": {
      borderRadius: '10px',
      backgroundColor: 'white',
      fontSize: '15px',
    },
    "& .MuiDataGrid-columnHeaders": {
      color: '#005A9C',
      fontSize: '16px',
    }
  },
};
// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
       



function PaymentLedger() {
    
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false},
    { field: 'Date', headerName: 'Date', editable: false, sortable: false, flex: 1, minWidth: 100  },
    { field: 'Invoice', headerName: 'Invoice', editable: false, sortable: false, flex: 1, minWidth: 100 },
    { field: 'Payment', headerName: 'Payment', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Balance', headerName: 'Balance', editable: false, sortable: false, flex: 1, minWidth: 100 },
    
    ];
    
     
    
    const rows = [
    { id: '', Date: '', Invoice: '', Payment: '', Balance:''}
    ]; 

    return (
      <form>
        <Box sx={dataGridStyle.root} mt={1}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default PaymentLedger